module.exports = __webpack_public_path__ + "static/img/PFK_OurTeam_Photo3_TestimonialsBkgd_1200x730.9c04374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurTeam_Photo3_TestimonialsBkgd_1200x730.jpg
// module id = 262
// module chunks = 1